import React from 'react';
import { Link } from 'react-router-dom';
import { showNotification } from './../../../utils';

const Templates = (props) => {
    const renderItems = () => {
        if (props.fetching) {
            return <div><i className="fas fa-circle-notch fa-spin" /> Loading data...</div>;
        }

        if (props.items.length === 0) {
            return <div>No items found</div>;
        }

        return props.items.map((item) => {
            const productType = parseInt(props.urlProductType);
            let imageStyle = null;
            let url = null;
            let color = null;

            if (productType === 1) {      // Cards
                if (props.platformType === 'utp') {
                    imageStyle = {
                        backgroundImage: 'url("' + item.preview_image_url + '")',
                        backgroundSize: '80%',
                    };
                } else {
                    imageStyle = {
                        backgroundImage: 'url("' + item.preview_image_url + '")',
                        backgroundColor: '#dadce0',
                        backgroundSize: '85%',
                    };
                }

                url = '/template/' + item.productType + '/' + item.code;
            } else if (productType === 17) {      // Pocket Folders
                imageStyle = {
                    backgroundImage: 'url("' + item.preview_image_url + '")',
                    backgroundColor: '#dadce0',
                    backgroundSize: '75%',
                };

                url = '/template/' + item.productType + '/' + item.code;
            } else if (productType === 2) {      // Letterheads
                if (props.platformType === 'utp') {
                    imageStyle = {
                        backgroundImage: 'url("' + item.preview_image_url + '")',
                        backgroundColor: '#dadce0',
                        backgroundSize: parseInt(item.code) === 2 ? '70%' : '100%',
                    };
                } else {
                    imageStyle = {
                        backgroundImage: 'url("' + item.preview_image_url + '")',
                        backgroundColor: '#dadce0',
                        backgroundSize: '72%',
                    };
                }
                
                url = '/template/' + item.productType + '/' + item.code;
            } else if (productType === 3) {      // Envelopes
                if (props.platformType === 'utp') {
                    let backgroundSize = '100%';

                    if (parseInt(item.code) === 1) {
                        backgroundSize = '120%';
                    } else if (parseInt(item.code) === 2) {
                        backgroundSize = '100%';
                    } else if (parseInt(item.code) === 3) {
                        backgroundSize = '90%';
                    }

                    imageStyle = {
                        backgroundImage: 'url("' + item.preview_image_url + '")',
                        backgroundColor: '#dadce0',
                        backgroundSize: backgroundSize,
                    };
                } else {
                    imageStyle = {
                        backgroundImage: 'url("' + item.preview_image_url + '")',
                        backgroundColor: '#dadce0',
                        backgroundSize: '90%',
                    };
                }
                
                url = '/template/' + item.productType + '/' + item.code;
            } else if (productType === 4) {      // Notecards
                if (props.platformType === 'utp') {
                    imageStyle = {
                        backgroundImage: 'url("' + item.preview_image_url + '")',
                        backgroundColor: '#dadce0',
                        backgroundSize:'90%',
                    };

                    if (parseInt(item.productType) === 4 && parseInt(item.code) === 10) {
                        url = '/myuthealth/' + item.productType + '/' + item.code;
                    } else {
                        url = '/template/' + item.productType + '/' + item.code;
                    }
                } else {
                    imageStyle = {
                        backgroundImage: 'url("' + item.preview_image_url + '")',
                        backgroundColor: '#dadce0',
                        backgroundSize: '60%',
                    };

                    url = '/template/' + item.productType + '/' + item.code;
                }
            } else if (productType === 18) {      // Notepads
                imageStyle = {
                    backgroundImage: 'url("' + item.preview_image_url + '")',
                    backgroundColor: '#dadce0',
                    backgroundSize: '70%',
                };

                url = '/template/' + item.productType + '/' + item.code;
            } else if (productType === 5) {      // Forms
                if (parseInt(item.uthealth_department_id) === 419) {
                    imageStyle = {
                        backgroundImage: 'url("' + item.front_image_url + '")',
                        backgroundSize: '62%',
                    };
                    url = '/brochure/16/' + item.uthealth_department_id + '/' + item.id;

                    if ([3, 4, 5, 6, 7].includes(parseInt(item.id))) {
                        color = <div className="mt-1"><b>Framed Poster</b></div>;
                    } else if (parseInt(item.id) === 9) {
                        color = <div className="mt-1"><b>Framed Poster</b></div>;
                    } else if (parseInt(item.id) === 10) {
                        color = <div className="mt-1"><b>Framed Poster</b></div>;
                    } else if (parseInt(item.id) === 640) {
                        url = '/static-template/5/338/' + item.id;
                        color = <div className="mt-1"><b>Handout</b></div>;
                    }
                } else {
                    imageStyle = {
                        backgroundImage: 'url("' + item.image_url + '")',
                        backgroundSize: '75%',
                    };
                    url = '/static-template/5/' + item.uthealth_department_id + '/' + item.id;
                }                
            } else if (productType === 7) {      // Adult Apparel
                imageStyle = {
                    backgroundImage: 'url("' + item.preview_image_url + '")',
                    backgroundSize: 'cover',
                };
    
                url = '/apparel-item/7/' + item.breadcrumbs[item.breadcrumbs.length - 1].id + '/' + item.id;
            } else if (productType === 16) {      // Marketing
                
            }

            return (
                <div className="category" key={item.id}>
                    <Link to={url}><div className="image" style={imageStyle}></div></Link>
                    <div className="title">
                        <div className="name">{item.name}{color}</div>
                        <div className="button-container">
                            <Link to={url}><button>Select</button></Link>
                        </div>
                    </div>
                </div>
            );
        });
    };

    const handleSearch = () => {
        if (props.search === '') {
            return showNotification('Enter a value', 'Enter a text to search', 'info');
        }

        props.history.push('/search/' + props.productType + '/' + props.search);
    };

    const keyPressHandler = (event) => {
        if (event.key === 'Enter') {
            if (props.search === '') {
                return showNotification('Enter a value', 'Enter a text to search', 'info');
            }
            
            props.history.push('/search/' + props.productType + '/' + props.search);
        }
    }

    return (
        <div className="templates-container">
            <div className="search-container">
                <div className="search-field">
                    <input
                        type="text"
                        placeholder="Search here..."
                        value={props.search}
                        onChange={(event) => props.setSearch(event.target.value)}
                        onKeyPress={keyPressHandler}
                    />
                    <select
                        value={props.productType}
                        onChange={(event) => props.setProductType(event.target.value)}
                    >
                        <option value="1">Cards</option>
                        <option value="17">Pocket Folders</option>
                        <option value="2">Letterheads</option>
                        <option value="3">Envelopes</option>
                        <option value="4">Notecards</option>
                        <option value="18">Notepads</option>
                        <option value="5">Forms</option>
                        <option value="7">Adult Apparel</option>
                        <option value="8">Promotional</option>
                        {/* <option value="16">Marketing</option> */}
                    </select>
                    <div className="button" onClick={handleSearch}>Search</div>
                </div>
            </div>
            <div className="templates-row">
                {renderItems()}
            </div>
        </div>
    );
}

export default Templates;
